


































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  IClientTemplateSlot,
  IClientTemplateSlotMapping
} from "@/models/templates";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";

@Component({
  components: {
    "template-preview-dropdown": () =>
      import("@/components/app/global/templates/templatePreviewDropdown.vue")
  }
})
export default class ClientsSlotsListItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public templateSlot?: IClientTemplateSlot;

  @Prop({ default: undefined })
  public mapping?: IClientTemplateSlotMapping;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public canDeleteMapping!: boolean;

  @Prop({ default: true })
  public canCreateMapping!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  public get template() {
    return this.mapping?.template;
  }

  public get i18n() {
    return {
      mainAction: this.template
        ? this.$t("_action.update_template")
        : this.$t("_action.add_template")
    };
  }

  // Methods

  public getPreviewSrc(code = "empty") {
    switch (code) {
      case ClientTemplateSlotCodes.AFFILIATES_OVERVIEW:
      case ClientTemplateSlotCodes.BASKET_SUMMARY_FOOTER:
      case ClientTemplateSlotCodes.CONTRACT_PRODUCT_OVERVIEW:
      case ClientTemplateSlotCodes.DASHBOARD_OVERVIEW:
      case ClientTemplateSlotCodes.FOOTER:
      case ClientTemplateSlotCodes.LOGIN_PAGE:
      case ClientTemplateSlotCodes.REGISTER_PAGE:
      case ClientTemplateSlotCodes.SUPPORT_OVERVIEW:
      case "empty":
        return `/assets/images/interface/slot-previews/${code}.png`;
      default:
        return;
    }
  }

  public onCta() {
    if (this.template) {
      this.$emit("updateTemplate", this.template);
    } else {
      this.$emit("createMapping");
    }
  }
}
